export const BUDGET_LIST = [
  '～50万円',
  '50～100万円',
  '150～200万円',
  '200万円～',
];
